'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var detect = function detect(globalKey) {
    if (globalKey) {
        window[globalKey] = false;
    }

    if (typeof Image !== 'undefined') {
        var img = new Image();
        img.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';

        return new Promise(function (resolve) {
            // eslint-disable-next-line
            img.onload = img.onerror = function () {
                if (img.width === 2 && img.height === 2) {
                    if (globalKey) {
                        window[globalKey] = true;
                    }
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
        });
    }
    return Promise.resolve(false);
};

function webp() {
    var globalKey = '__GLOBAL_WEBP_SUPPORT_IDENTITY__';
    detect(globalKey);

    return {
        detect: detect,
        use: function use(url) {
            if (!url) {
                return '';
            }

            if (window[globalKey] && !/_\.webp$/.test(url)) {
                return url + '_.webp';
            }
            return url;
        }
    };
}

exports['default'] = webp();
module.exports = exports['default'];